/* Preço dentro do botão comprar — item 10 da fila do MCP.
   🔴 Mora num arquivo de asset, e não num <script> dentro do bloco, porque um
   app de velocidade desta loja reescreve script inline para type="text/lazyload"
   e só o roda depois que a cliente interage — o botão ficaria sem preço até ela
   mexer na página. Script externo com defer o app não toca (é o mesmo caminho da
   barra de recompensas do carrinho). */

(() => {
  if (customElements.get('tn-preco-botao')) return;

  class TnPrecoBotao extends HTMLElement {
    connectedCallback() {
      this.sep = this.dataset.separador || '·';
      this.escopo = this.closest('product-info') || document;
      this.pintar();
      // O tema atualiza o preço de dois jeitos: disparando 'variant:update'
      // e trocando o innerHTML do <product-price>. Escuto os dois — o
      // observer sozinho já pegaria tudo, mas o evento chega antes.
      document.addEventListener('variant:update', () => this.pintar());
      const alvo = this.escopo.querySelector('product-price');
      if (alvo) {
        this.obs = new MutationObserver(() => this.pintar());
        this.obs.observe(alvo, { childList: true, subtree: true, characterData: true });
      }
    }

    disconnectedCallback() {
      if (this.obs) this.obs.disconnect();
    }

    precoAtual() {
      const cont = this.escopo.querySelector('product-price .price-product-container')
        || document.querySelector('product-price .price-product-container');
      if (!cont) return '';
      // O preço de venda vence o riscado; se não houver classe de venda,
      // pego o primeiro .price-item que não seja o comparativo.
      const venda = cont.querySelector('.price-item--sale')
        || cont.querySelector('.price-item:not(.price-item--regular)')
        || cont.querySelector('.price-item');
      return venda ? venda.textContent.trim().replace(/\s+/g, ' ') : '';
    }

    pintar() {
      const botao = document.getElementById(this.dataset.botao)
        || this.escopo.querySelector('.add-to-cart-button');
      if (!botao || botao.disabled) {
        this.limpar(botao);
        return;
      }
      const rotulo = botao.querySelector('.add-to-cart-text__content');
      if (!rotulo) return;
      const preco = this.precoAtual();
      let span = rotulo.querySelector('.tn-atc-preco');
      if (!preco) {
        if (span) span.remove();
        return;
      }
      if (!span) {
        span = document.createElement('span');
        span.className = 'tn-atc-preco';
        rotulo.appendChild(span);
      }
      const texto = ' ' + this.sep + ' ' + preco;
      if (span.textContent !== texto) span.textContent = texto;
    }

    limpar(botao) {
      const span = botao && botao.querySelector('.tn-atc-preco');
      if (span) span.remove();
    }
  }

  customElements.define('tn-preco-botao', TnPrecoBotao);
})();
